import React, { useRef, useEffect, useState } from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';
import AppConfig from '../config/appConfig'; // path আপনার ফোল্ডার স্ট্রাকচার অনুযায়ী ঠিক করুন

function SearchOverlay({ isOpen, onClose, searchTerm, onSearchChange, onSearchSubmit }) {
  const inputRef = useRef(null);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  const placeholders = [
    `Search ${AppConfig.CompanyName}`,
    'Search your best choice',
    'Keyboard',
    'Headphones',
    'Laptop',
    'Books',
    'Electronics',
    'Fashion'
  ];

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearchSubmit();
      onClose();
    }
  };

  return (
    <div
      className={`fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] transition-opacity duration-300 ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg w-[90%] max-w-2xl shadow-lg relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 text-2xl transition-colors"
        >
          <FaTimes />
        </button>

        <div className="p-5">
          <div className="flex items-center border-2 border-[#FF9900] rounded-md overflow-hidden shadow-sm hover:shadow-md transition-shadow">
            <input
              ref={inputRef}
              type="text"
              placeholder={placeholders[placeholderIndex]}
              value={searchTerm}
              onChange={onSearchChange}
              onKeyDown={handleKeyDown}
              className="flex-1 px-4 py-3 text-base outline-none border-none placeholder:text-gray-400"
            />
            <button
              onClick={() => {
                onSearchSubmit();
                onClose();
              }}
              className="bg-[#FEBD69] hover:bg-[#FF9900] px-5 py-3 transition-colors"
            >
              <FaSearch className="text-gray-800 text-xl" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchOverlay;